// @flow
import { ReactComponent as Icon } from 'esm-web-pro/assets/images/sidePanel/meatballs.svg';
import styled from 'styled-components';


const MeatballsIcon = styled(Icon)`
    pointer-events: none;
`;
export default MeatballsIcon;
